export const TEST_DATA_KEY_PREFIX = "@testData:";

/**
 * Called on class-member logout so a member's answers never outlive their session — the next person
 * on a shared device must not find them.
 */
export const clearAllPersistedTestData = () => {
    try {
        for (let i = window.localStorage.length - 1; i >= 0; i--) {
            const key = window.localStorage.key(i);
            if (key && key.startsWith(TEST_DATA_KEY_PREFIX)) {
                window.localStorage.removeItem(key);
            }
        }
    } catch {
        // localStorage may be disabled (private mode); nothing to do.
    }
};
